import { useTranslation } from 'react-i18next';
import { sharedErrorStringsEN } from 'shared/hooks/errorFormatters/sharedErrorStrings.en';

export type DefaultError = {
  defaultTitle: string;
  defaultMessage: string;
  graphqlErrorsTitle: string;
  retryButtonTitle: string;
  cancelButtonTitle: string;
};

/**
 * Returns the localized default error strings for use in building
 * local errors on screens.
 */
export const useDefaultErrorStrings = () => {
  const { t: translatedText } = useTranslation('sharedError');
  return {
    defaultTitle: translatedText(
      'title.default',
      sharedErrorStringsEN.title.default,
    ),
    defaultMessage: translatedText(
      'message.default',
      sharedErrorStringsEN.message.default,
    ),
    graphqlErrorsTitle: translatedText(
      'title.gqlErrors',
      sharedErrorStringsEN.title.gqlErrors,
    ),
    retryButtonTitle: translatedText(
      'buttons.retry',
      sharedErrorStringsEN.buttons.retry,
    ),
    cancelButtonTitle: translatedText(
      'buttons.cancel',
      sharedErrorStringsEN.buttons.cancel,
    ),
    doneButtonTitle: translatedText(
      'buttons.done',
      sharedErrorStringsEN.buttons.done,
    ),
    pageDownTitle: translatedText(
      'pageDown.title',
      sharedErrorStringsEN.pageDown.title,
    ),
    pageDownMessage: translatedText(
      'pageDown.message',
      sharedErrorStringsEN.pageDown.message,
    ),
  };
};
